<template>
	<article class="teach-items">
    <h2>评委采访</h2>
    <div class="item-tech">
      <!-- <img src='/assets/li.jpg'> -->
	    <video-player  class=" vjs-custom-skin"
                     ref="videoPlayer"
                     :playsinline="true"
                     :options="playerOptionsLi"
                     @play="onPlayerPlay($event)"
                     @pause="onPlayerPause($event)"
      >
      </video-player>
    </div>
    
    <div class="item-tech">
      <!-- <img src='/assets/xia.jpg'> -->
      <video-player  class="vjs-custom-skin"
                     ref="videoPlayer"
                     :playsinline="true"
                     :options="playerOptionsXia"
                     @play="onPlayerPlay($event)"
                     @pause="onPlayerPause($event)"
      >
      </video-player>
    </div>
   
    <div class="item-tech">
      <!-- <img src='/assets/zhu.jpg'> -->
      <video-player  class="vjs-custom-skin"
                     ref="videoPlayer"
                     :playsinline="true"
                     :options="playerOptionsZhu"
                     @play="onPlayerPlay($event)"
                     @pause="onPlayerPause($event)"
      >
      </video-player>
    </div>

    <div class="item-tech">
      <video-player  class="vjs-custom-skin"
                     ref="videoPlayer"
                     :playsinline="true"
                     :options="playerOptionsHu"
                     @play="onPlayerPlay($event)"
                     @pause="onPlayerPause($event)"
      >
      </video-player>
    </div>


<!--
      <div class="item-tech">
    <h2>优秀作品</h2>
      <video-player  class="vjs-custom-skin"
                     ref="videoPlayer"
                     :playsinline="true"
                     :options="playerOptions1"
                     @play="onPlayerPlay($event)"
                     @pause="onPlayerPause($event)"
      >
      </video-player>
      </div>
      <div class="item-tech">
      <video-player  class="vjs-custom-skin"
                     ref="videoPlayer"
                     :playsinline="true"
                     :options="playerOptions2"
                     @play="onPlayerPlay($event)"
                     @pause="onPlayerPause($event)"
      >
      </video-player>
      </div>
      <div class="item-tech">
      <video-player  class="vjs-custom-skin"
                     ref="videoPlayer"
                     :playsinline="true"
                     :options="playerOptions3"
                     @play="onPlayerPlay($event)"
                     @pause="onPlayerPause($event)"
      >
      </video-player>
      </div>
      <div class="item-tech">
      <video-player  class="vjs-custom-skin"
                     ref="videoPlayer"
                     :playsinline="true"
                     :options="playerOptions4"
                     @play="onPlayerPlay($event)"
                     @pause="onPlayerPause($event)"
      >
      </video-player>
      </div>
-->
	</article>
</template>

<script>
import { videoPlayer } from 'vue-video-player'

export default {
  components: {
    videoPlayer
  },
  data () {
    return {
      playerOptionsLi: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/mp4',
          src: 'http://ss.archirookies.com/assets/zhulei.mp4'
        }],
        poster: 'http://ss.archirookies.com/assets/zhulei.jpg'
      },
      playerOptionsZhu: {
        height: '240',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/mp4',
          src: 'http://ss.archirookies.com/assets/yangzhijiang.mp4'
        }],
        poster: 'http://ss.archirookies.com/assets/yangzhijiang.jpg'
      },
      playerOptionsXia: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/mp4',
          src: 'http://ss.archirookies.com/assets/jieyuqi.mp4'
        }],
        poster: 'http://ss.archirookies.com/assets/jieyuqi.jpg'
      },
      playerOptionsHu: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/mp4',
          src: 'http://ss.archirookies.com/assets/xinshanchao.mp4'
        }],
        poster: 'http://ss.archirookies.com/assets/xinshanchao.jpg'
      },
      playerOptions1: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/mp4',
          src: 'http://ss.archirookies.com/assets/zuopin1.mp4'
        }],
        poster: 'poster.jpg'
      },
      playerOptions2: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/mp4',
          src: 'http://ss.archirookies.com/assets/zuopin2.mp4'
        }],
        poster: 'poster.jpg'
      },
      playerOptions3: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/mp4',
          src: 'http://ss.archirookies.com/assets/zuopin3.mp4'
        }],
        poster: 'poster.jpg'
      },
      playerOptions4: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/mp4',
          src: 'http://ss.archirookies.com/assets/zuopin4.mp4'
        }],
        poster: 'poster.jpg'
      }
    }
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    }
  },
  methods: {
    onPlayerPlay (player) {
    },
    onPlayerPause (player) {
    }
  }
}
</script>

<style scoped>
.item-tech {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 2em;
}
.item-tech > div{
  flex: none;
}
h2 {
  text-align: center;
  font-size: 30px;
}
h3 {
  text-align: center;
  font-size: 20px;
}
</style>
<style>
.video-js .vjs-big-play-button{
  top: 50%;
  left: 50%;
}
</style>



// WEBPACK FOOTER //
// Award.vue?0df2352c